import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { GatilhoEmissao, SalvarGatilhoPayload } from './gatilho.model';

@Injectable({ providedIn: 'root' })
export class GatilhoService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Gatilho`;

  listar(filtros?: { evento?: string; situacao?: string }): Observable<ApiResponse<GatilhoEmissao[]>> {
    let params = new HttpParams();
    if (filtros?.evento)   params = params.set('evento', filtros.evento);
    if (filtros?.situacao) params = params.set('situacao', filtros.situacao);
    return this.http.get<ApiResponse<GatilhoEmissao[]>>(this.url, { params });
  }

  obter(nrSequencia: number): Observable<ApiResponse<GatilhoEmissao>> {
    return this.http.get<ApiResponse<GatilhoEmissao>>(`${this.url}/${nrSequencia}`);
  }

  criar(payload: SalvarGatilhoPayload): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(this.url, payload);
  }

  atualizar(nrSequencia: number, payload: SalvarGatilhoPayload): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.url}/${nrSequencia}`, payload);
  }

  inativar(nrSequencia: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/${nrSequencia}`);
  }
}
